import { Farm } from '@/common/interface/farm.data.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FarmEnvironmentService } from '@services/farm-environment.service';
import { FarmService } from '@services/farm.service';
import {
    DashboardKeyMetrics,
    DashboardKeyMetricsService
} from '@services/dashboard-key-metrics.service';
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
    readingForm: FormGroup;
    userDetail: any;
    farmlist: any = [];
    public displayfarm: boolean = false;
    public farms: any[] = [];
    // Farm filter UI state
    showFarmMenu = false;
    // Dashboard key metrics
    keyMetrics: DashboardKeyMetrics | null = null;
    isMetricsLoading = false;
    loadGraphs = false;

    constructor(
        private farmService: FarmEnvironmentService,
        private fb: FormBuilder,
        private farmsService: FarmService,
        private router: Router,
        private dashboardKeyMetricsService: DashboardKeyMetricsService
    ) {}

    ngOnInit(): void {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.getFarmList(this.userDetail.id);
        this.loadFarms(this.userDetail.id);
        this.readingForm = this.fb.group({
            farmId: ['', Validators.required]
        });
        // Close menu on outside click (bubble phase so inner clicks can handle first)
        document.addEventListener('click', this.onDocumentClick, false);
    }
    ngOnDestroy(): void {
        document.removeEventListener('click', this.onDocumentClick, false);
    }
    loadFarms(userId: number): void {
        this.farmsService
            .getFarmDashboardList(userId)
            .subscribe((data: Farm[]) => {
                this.farms = data;
                if (this.farms.length == 0) {
                    this.displayfarm = true;
                }
            });
    }
    onCloseFarmDialog() {
        this.displayfarm = false;
        this.router.navigate(['/']);
        this.getFarmList(this.userDetail.id);
    }
    getFarmList(userId: number) {
        this.farmService.getdashboardFarmList(userId).subscribe((result) => {
            this.farmlist = result;
            if (this.farmlist.length > 0) {
                // Set the first farm as default and trigger related data loading
                const defaultFarmId = this.farmlist[0].id;
                this.readingForm.patchValue({farmId: defaultFarmId});
                // Load dashboard key metrics for the default farm
                this.loadKeyMetrics(defaultFarmId);
            }
        });
    }

    onFarmChange(farmId: number): void {
        // Ensure metrics are refreshed when farm changes
        const parsedFarmId =
            typeof farmId === 'string' ? parseInt(farmId, 10) : farmId;
        if (parsedFarmId) {
            this.loadKeyMetrics(parsedFarmId);
        }
    }

    // Farm filter menu helpers
    get currentFarmName(): string {
        const id = this.readingForm?.get('farmId')?.value;
        const farm = this.farmlist?.find((f: any) => f.id == id);
        return farm?.name || 'Farm';
    }

    toggleFarmMenu(event: MouseEvent) {
        this.showFarmMenu = !this.showFarmMenu;
    }

    selectFarm(farm: any, event: MouseEvent) {
        if (farm?.id !== this.readingForm.get('farmId')?.value) {
            this.readingForm.patchValue({farmId: farm.id});
            this.onFarmChange(farm.id);
        }
        this.showFarmMenu = false;
    }

    private onDocumentClick = (event: MouseEvent) => {
        const target = event.target as HTMLElement | null;
        if (target && target.closest('.farm-filter')) {
            return;
        }
        if (this.showFarmMenu) this.showFarmMenu = false;
    };

    private loadKeyMetrics(farmId: number) {
        this.isMetricsLoading = true;
         this.loadGraphs = true;
        this.dashboardKeyMetricsService
            .getDashboardKeyMetrics(farmId)
            .subscribe({
                next: (res) => {
                    this.keyMetrics = res;
                    this.isMetricsLoading = false;

                     setTimeout(() => {
                    this.loadGraphs = true;
                }, 7000);
                },
                error: () => {
                    this.keyMetrics = null;
                    this.isMetricsLoading = false;
                }
            });
    }
}
